import {Component, Input, OnChanges} from '@angular/core';
import {ImagemAvisoAtualizacaoVM} from '../../services/avisos-atualizacao.service';

@Component({
  selector: 'app-galeria-imagens-aviso',
  templateUrl: './galeria-imagens-aviso.component.html',
  styleUrls: ['./galeria-imagens-aviso.component.scss']
})
export class GaleriaImagensAvisoComponent implements OnChanges {
  @Input() imagens: ImagemAvisoAtualizacaoVM[] = [];
  indice: number = null;
  private origem: HTMLElement;
  private toqueX = 0;

  ngOnChanges(): void {
    this.indice = null;
    this.origem = null;
  }

  abra(indice: number, origem: HTMLElement): void {
    this.origem = origem;
    this.indice = indice;
  }

  feche(): void {
    this.indice = null;
    this.origem?.focus();
  }

  navegue(direcao: number): void {
    if (this.indice === null || !this.imagens?.length) return;
    this.indice = (this.indice + direcao + this.imagens.length) % this.imagens.length;
  }

  tecla(evento: KeyboardEvent): void {
    evento.stopPropagation();
    if (evento.key === 'Escape') {
      evento.preventDefault();
      this.feche();
    } else if (evento.key === 'ArrowLeft' || evento.key === 'ArrowRight') {
      evento.preventDefault();
      this.navegue(evento.key === 'ArrowLeft' ? -1 : 1);
    }
  }

  inicieToque(evento: TouchEvent): void {
    this.toqueX = evento.changedTouches[0].clientX;
  }

  termineToque(evento: TouchEvent): void {
    const deslocamento = evento.changedTouches[0].clientX - this.toqueX;
    if (Math.abs(deslocamento) >= 50) this.navegue(deslocamento < 0 ? 1 : -1);
  }
}
